
export const formatDateToDDMMYYYY = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

export const currentMonthDateToDDMMYYYY = () => {
    const now = new Date();
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const day = String(firstDayOfMonth.getDate()).padStart(2, '0');
    const month = String(firstDayOfMonth.getMonth() + 1).padStart(2, '0');
    const year = firstDayOfMonth.getFullYear();

    return `${year}-${month}-${day}`;
};